import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
    Grid
} from "@material-ui/core";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../../actions/ui/alertas";
import { TextValidator } from "react-material-ui-form-validator";

export const BuscadorRnos = (props) => {
    const [options, setOptions] = useState([]);
    const { rnos, nroTraspaso } = props;
    const dispatch = useDispatch();

    const transformarLista = (lista)=>{
      return lista.map((item)=>(
            { 
                rnos: item.rnosclean, 
                denominacion: item.denominacion
            }
        ));
    }
    const handleBuscar = async () => {
        try {
            const result = await fetchConToken(
                `RNOS`
            );
            const body = await result.json()
            if (result.ok) {
                if (body.length > 0) {
                    //console.log('resultado',lista);
                    setOptions(
                        transformarLista(body)
                    );
                }

            } else {
                throw body.errores
            }
        } catch (error) {
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Error al buscar. Intente nuevamente", "error"))
            }
            console.log("Error al buscar", error)
        }
    }

    useEffect(() => {
        handleBuscar()
        // eslint-disable-next-line
    }, []);

    return (
        <Grid container>
            <Grid item xs={3}>
                <TextValidator
                    margin="normal"
                    value={nroTraspaso}
                    disabled={props.disabled}
                    onChange={props.handleInputChange}
                    fullWidth
                    label="Nro. de traspaso"
                    name="nro_traspaso"
                    autoComplete="off"
                    InputLabelProps={{ shrink: true }}  
                    validators={["required"]}
                    errorMessages={["El número de traspaso es requerido"]}
                />
            </Grid>
            <Grid item xs={6} sm={6} style={{padding: 15}}>
                {options.length>0&&
                    <Autocomplete
                        id="combo-box-demo"
                        noOptionsText="Sin resultados"
                        disabled={props.disabled}
                        options={options}
                        value={options.find(e => e.rnos === rnos)}
                        getOptionSelected={(option, value) => {
                            if (rnos === null || typeof rnos !== "object") {
                                return option.rnos === value
                            } else {
                                return option.rnos === value.rnos
                            }
                        }
                        }
                        onChange={(e, selected) => {
                            props.manejadorInputChange({ target: { name: 'rnos', value: selected?.rnos !== null ? selected?.rnos : null } });
                        }}
                        getOptionLabel={(option) => `${option.denominacion} | ${option.rnos}`}
                        renderInput={
                            (params) => {
                                return <TextValidator
                                    {...params}
                                    label="Buscar Rnos..."
                                    value={params.inputProps.value}
                                    validators={["required"]}
                                    errorMessages={["El número de traspaso es requerido"]}
                                />
                            }

                        }
                    />
                }
            </Grid>
        </Grid>
    );
};
